/**
 * popup定位基准模块
 */
import React from 'react';

import styles from './index.module.scss';
import { TargetType } from './helper';

interface IProps {
  id: TargetType;
}

const Index: React.FC<IProps> = (props) => {
  return <div id={props.id} className={styles.popupTarget} />;
};

export * from './helper';
export default Index;
